import { Badge } from "@/components/ui/badge";

export function DevBadge() {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }
  return <Badge variant="destructive">DEV</Badge>;
}
